export default __webpack_public_path__ + "static/card1-88694e63b19f202c4ecab0747dc2314b.png";